export const getPreviousPageIndex = (currentPage: number): number => {
  return currentPage <= 0 ? 0 : currentPage - 1;
};

export const getNextPageIndex = (currentPage: number, totalPages: number): number => {
  if (totalPages <= 0) {
    return 0;
  }

  const lastPageIndex = totalPages - 1;
  return currentPage >= lastPageIndex ? lastPageIndex : currentPage + 1;
};

export const normalizePageFromUrl = (pageFromUrl: string | null, totalPages: number): number => {
  if (!pageFromUrl) {
    return 0;
  }

  const parsed = Number.parseInt(pageFromUrl, 10);
  if (!Number.isFinite(parsed) || parsed < 1) {
    return 0;
  }

  const zeroBasedPage = parsed - 1;
  if (totalPages <= 0) {
    return 0;
  }

  const lastPageIndex = totalPages - 1;
  return zeroBasedPage > lastPageIndex ? lastPageIndex : zeroBasedPage;
};
